module.exports = __webpack_public_path__ + "a2bb794a6564700dcd10766ff633478d.jpg";